import { render, staticRenderFns } from "./addCommunityRecommend.vue?vue&type=template&id=7105dd4f&scoped=true"
import script from "./addCommunityRecommend.vue?vue&type=script&lang=js"
export * from "./addCommunityRecommend.vue?vue&type=script&lang=js"
import style0 from "./addCommunityRecommend.vue?vue&type=style&index=0&id=7105dd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7105dd4f",
  null
  
)

export default component.exports